import { Topbar } from '../../components/Topbar/Topbar';
import { Alert, Badge, Button, Container, Modal } from 'react-bootstrap';
import { Footer } from '../../components/Footer/Footer';
import { useFirebase } from '../../../contexts/FirebaseContext';
import { Title } from '../../components/Title/Title';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';
import { faCloudDownloadAlt, faListOl } from '@fortawesome/free-solid-svg-icons';
import JSONInput from 'react-json-editor-ajrm';
import locale from 'react-json-editor-ajrm/locale/en';
import { faTrashAlt } from '@fortawesome/free-regular-svg-icons';

const CacheComponent = () => {
  const { manageCache } = useFirebase();

  const [confirmModal, setConfirmModal] = useState(false);
  const [pendingOperation, setPendingOperation] = useState<any>({});
  const [loadingModal, setLoadingModal] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const [successResponse, setSuccessResponse] = useState(null);
  const [successTime, setSuccessTime] = useState(null);

  const keys = [
    'authors',
    'billboard_odontoiatra',
    'billboard_odontoiatra_it',
    'billboard_odontoiatra_es',
    'billboard_odontoiatra_en',
    'billboard_aso',
    'billboard_aso_it',
    'billboard_aso_es',
    'billboard_aso_en',
    'courses_odontoiatra',
    'courses_aso',
    'homePromoCodes',
    'mostViewed_odontoiatra',
    'mostViewed_odontoiatra_it',
    'mostViewed_odontoiatra_es',
    'mostViewed_odontoiatra_en',
    'mostViewed_aso',
    'mostViewed_aso_it',
    'mostViewed_aso_es',
    'mostViewed_aso_en',
    // 'series',
    'staticData',
    'stripeDashboard',
    'tags',
    'tags_it',
    'tags_es',
    'tags_en',
    'videos_admin',
    'videos_odontoiatra',
    'videos_odontoiatra_it',
    'videos_odontoiatra_es',
    'videos_odontoiatra_en',
    'videos_aso',
    'videos_aso_it',
    'videos_aso_es',
    'videos_aso_en',
  ];

  const operations = [
    {
      leading: faListOl,
      label: 'SCAN',
      variant: 'warning',
      fn: manageCache('SCAN_REDIS_CACHE'),
      confirm: false,
    },
    {
      leading: faCloudDownloadAlt,
      label: 'DUMP',
      variant: 'warning',
      fn: manageCache('DUMP_REDIS_CACHE'),
      confirm: false,
    },
    null,
    ...keys.map((key) => ({
      leading: null,
      label: `GET ${key}`,
      variant: 'outline-warning',
      fn: manageCache('GET_REDIS_KEY', key),
      confirm: false,
    })),
    null,
    ...keys.map((key) => ({
      leading: null,
      label: `DEL ${key}`,
      variant: 'outline-danger',
      fn: manageCache(`DEL_REDIS_KEY`, key),
      confirm: true,
    })),
    null,
    {
      leading: faTrashAlt,
      label: 'FLUSH DB',
      variant: 'danger',
      fn: manageCache('CLEAR_REDIS_CACHE'),
      confirm: true,
    },
  ];

  useEffect(() => {
    if (!confirmModal && pendingOperation.label) {
      setLoadingModal(true);
      pendingOperation
        .fn()
        .then(({ data, time }) => {
          setSuccessResponse(data);
          setSuccessTime(time);
          setSuccessModal(true);
        })
        .catch(console.error)
        .finally(() => {
          setLoadingModal(false);
          setPendingOperation({});
        });
    }
  }, [confirmModal, pendingOperation]);

  return (
    <>
      <Title>Gestione cache</Title>
      <Topbar />
      <Container className={'my-5'}>
        <div className={'d-flex align-items-center'}>
          <div className={'display-4'}>Gestione cache</div>
        </div>

        <div className={'mt-4'}>
          <Alert variant={'danger'} className={'mb-4'}>
            <strong>Attenzione!</strong> Le seguenti sono funzionalità molto delicate. Procedere con cautela e solo se consapevoli di cosa si sta per fare.
            <br />
            Le operazioni in rosso necessitano di conferma e sono registrate nel log degli eventi.
          </Alert>

          {operations.map((op) =>
            op ? (
              <Button
                key={op.label}
                disabled={!!pendingOperation.label}
                variant={op.variant}
                className={'mr-2 mb-2'}
                onClick={() => {
                  setPendingOperation(op);
                  if (op.confirm) setConfirmModal(true);
                }}
              >
                {op.leading && <FontAwesomeIcon icon={op.leading} className={'mr-2'} fixedWidth={true} />}
                {(() => {
                  if (op.label.startsWith('GET ') || op.label.startsWith('DEL '))
                    return (
                      <span>
                        <Badge>{op.label.slice(0, 3)}</Badge> <small>{op.label.slice(4)}</small>
                      </span>
                    );
                  return <span>{op.label}</span>;
                })()}
              </Button>
            ) : (
              <div key={Math.random()} className={'border border-dark mb-2'} />
            )
          )}
        </div>
      </Container>

      <Footer />

      <Modal show={confirmModal} onHide={() => setConfirmModal(false)} centered backdrop={'static'} keyboard={false}>
        <Modal.Header>
          <Modal.Title>Conferma operazione</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Stai per eseguire l'operazione "<strong>{pendingOperation.label}</strong>".
          <br />
          Confermi di voler procedere?
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant={'secondary'}
            onClick={() => {
              setPendingOperation({});
              setConfirmModal(false);
            }}
          >
            Annulla
          </Button>
          <Button variant={'danger'} onClick={() => setConfirmModal(false)}>
            Conferma
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={loadingModal} onHide={() => setLoadingModal(false)} centered backdrop={'static'} keyboard={false}>
        <Modal.Body>Attendere&hellip;</Modal.Body>
      </Modal>

      <Modal size={'xl'} show={successModal} onHide={() => setSuccessModal(false)} centered backdrop={'static'} keyboard={false} scrollable>
        <Modal.Header>
          <Modal.Title>Operazione eseguita con successo</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className={'mb-2'}>
            Response length: <strong>{JSON.stringify(successResponse).length}</strong> | Response time: <strong>{successTime}</strong>
          </div>
          {(() => {
            if (typeof successResponse != 'object') return <pre className={'mb-0'}>{JSON.stringify(successResponse, null, 2)}</pre>;
            return (
              <JSONInput
                locale={locale}
                style={{ outerBox: { width: '100%' }, container: { width: '100%' } }}
                confirmGood={false}
                placeholder={successResponse}
                viewOnly={true}
              />
            );
          })()}
        </Modal.Body>
        <Modal.Footer>
          <Button variant={'secondary'} onClick={() => setSuccessModal(false)}>
            Chiudi
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CacheComponent;
